import React from "react";
import MemberCard from '../Billing/MemberCard'
import CancelAccount from './CancelAccount'
import { Elements } from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js/pure";
import {STRIPE_KEY} from "../../config.json";

const stripePromise = loadStripe(STRIPE_KEY);


const MemberDetail = (props) => {

    return (
      <>
        <div className="member__detail">
          <Elements stripe={stripePromise}>
            <MemberCard Card={props} />
            <CancelAccount Card={props} />
          </Elements>
        </div>
      </>
    );
};
export default MemberDetail;
